module.exports = __webpack_public_path__ + "static/img/6.ae71807.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/6.png
// module id = P3jX
// module chunks = 0